"use strict";

class FATFBlacklistCountriesController {

    constructor($parse, $timeout, SSHttpService, SSUtilService, SSAlertService, SSUserService, OTPService, SSConfirmationService, SSConfigService, SSCountryListService) {
        const self = this;

        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSConfigService = SSConfigService;

        // WEB-4383: exposed on the controller because modal_country_list_refresh
        // binds straight to ctrl.SSCountryListService.
        self.SSCountryListService = SSCountryListService;

        self.data = SHOWSUITE.data;

        self.DEVELOPER_SETTINGS_PAYMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_PAYMENT_TRACKING_NUMBER;
        self.DEVELOPER_SETTINGS_INSTRUMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_INSTRUMENT_TRACKING_NUMBER;
        self.DEVELOPER_SETTINGS_PAYMENT_DAILY_FREEZING_SLOT = SHOWSUITE.DEVELOPER_SETTINGS_PAYMENT_DAILY_FREEZING_SLOT;
        self.DEVELOPER_SETTINGS_PAYMENT_MONTHLY_FREEZING_SLOT = SHOWSUITE.DEVELOPER_SETTINGS_PAYMENT_MONTHLY_FREEZING_SLOT;
        self.DEVELOPER_SETTINGS_DIFFERENT_OTP_FOR_COMMERCIAL_UNITS = SHOWSUITE.DEVELOPER_SETTINGS_DIFFERENT_OTP_FOR_COMMERCIAL_UNITS;
        self.DEVELOPER_SETTINGS_SESSION_TIMEOUT = SHOWSUITE.DEVELOPER_SETTINGS_SESSION_TIMEOUT;
        self.DEVELOPER_SETTINGS_PASSWORD_VALIDATION = SHOWSUITE.DEVELOPER_SETTINGS_PASSWORD_VALIDATION;
        self.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER = SHOWSUITE.DEVELOPER_SETTINGS_REFUND_PAYMENT_TRACKING_NUMBER;

        self.EMAIL_NOTIFICATION_SPA_DELIVERY_EXPIRY = SHOWSUITE.EMAIL_NOTIFICATION_SPA_DELIVERY_EXPIRY;
        self.EMAIL_NOTIFICATION_SPA_EXPIRY = SHOWSUITE.EMAIL_NOTIFICATION_SPA_EXPIRY;
        self.EMAIL_NOTIFICATION_OPTION_EXERCISED_SUMMARY = SHOWSUITE.EMAIL_NOTIFICATION_OPTION_EXERCISED_SUMMARY;
        self.EMAIL_NOTIFICATION_OPTION_EXERCISED = SHOWSUITE.EMAIL_NOTIFICATION_OPTION_EXERCISED;
        self.EMAIL_NOTIFICATION_OUTSTANDING_PROGRESSIVE_PAYMENTS = SHOWSUITE.EMAIL_NOTIFICATION_OUTSTANDING_PROGRESSIVE_PAYMENTS;
        
        self.EMAIL_NOTIFICATION_UPDATE_BUYER = SHOWSUITE.EMAIL_NOTIFICATION_UPDATE_BUYER;
        self.EMAIL_NOTIFICATION_UPDATE_BUYER_LAWYER = SHOWSUITE.EMAIL_NOTIFICATION_UPDATE_BUYER_LAWYER;
        self.EMAIL_NOTIFICATION_NEW_PAYMENT_RECEIVED = SHOWSUITE.EMAIL_NOTIFICATION_NEW_PAYMENT_RECEIVED;
        self.EMAIL_NOTIFICATION_PAYMENT_CLAUSES = SHOWSUITE.EMAIL_NOTIFICATION_PAYMENT_CLAUSES;
        self.EMAIL_NOTIFICATION_NEW_PROGRESSIVE_PAYMENTS = SHOWSUITE.EMAIL_NOTIFICATION_NEW_PROGRESSIVE_PAYMENTS;
        self.EMAIL_NOTIFICATION_NOTICE_SERVED_BY_LAWYER = SHOWSUITE.EMAIL_NOTIFICATION_NOTICE_SERVED_BY_LAWYER;
        self.EMAIL_NOTIFICATION_UNIT_RESERVED = SHOWSUITE.EMAIL_NOTIFICATION_UNIT_RESERVED;
        self.EMAIL_NOTIFICATION_UNIT_RESERVED_OVERTIME = SHOWSUITE.EMAIL_NOTIFICATION_UNIT_RESERVED_OVERTIME;

        self.FREQUENCY_DAILY = SHOWSUITE.FREQUENCY_DAILY;
        self.FREQUENCY_WEEKLY = SHOWSUITE.FREQUENCY_WEEKLY;
        self.FREQUENCY_MONTHLY = SHOWSUITE.FREQUENCY_MONTHLY;

        self.notifications = null;
        self.properties = null;

        self.const_dict_notifications = [];
        self.const_dict_frequencies = [];

        self.sessionTimeoutEditMode = false;
        self.passwordComplexityEditMode = false;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }

        self.selectedBlackListCountires = [];
    }

    init() {
        const self = this;

        self.invoice_no_settings = {};
        self.receipt_no_settings = {};

        self.refund_invoice_no_settings = {};

        self.developer_users = [];

        self.commission_approval_levels = [];

        self.countries = self.SSConfigService.getCountries();
        if(self.countries && self.countries.length){ // Convert Country name to urf-8 string
            self.countries = self.countries.map(c => {
                c.name = self.SSUtilService.convertUnicodeToUtf8String(c.name);
                return c;
            })
        }

        self.non_blacklisted_countries = self.SSConfigService.getCountries();
        self.$timeout(function () {
            $("select.eoi-select").niceSelect();
        });

        // Methods to prepare dictionaries against constants
        // Methods to get required data
        self.getDeveloperSettings();

        self.days = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];

    }

    getDeveloperUsers() {
        const self = this;

        let current_user = self.SSUserService.getUser();
        current_user.name = self.getUserFullName(current_user);
        self.developer_users.push(current_user);

        let url = 'sec/developer/users';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.users){
                $.each(response.data.users, function(index, user){
                    user.name = self.getUserFullName(user);
                    self.developer_users.push(user);
                });
            }
        });
    }

    getUserFullName(user){
        const self = this;

        let name = "";
        if(user){
            name = (user.first_name? user.first_name : "") + " " + (user.last_name? user.last_name : "");
        }

        return name;
    }

    // ----------- GENERAL SETTINGS SECTION  -------

    getDeveloperSettings() {
        const self = this;

        let url = 'sec/developer/settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.developer_settings){
                // Get FATF Blacklist Countries Settings
                self.fatf_blacklist_countries_settings = self.getSetting(response.data.developer_settings, 'fatf_blacklist_countries');
                if(self.fatf_blacklist_countries_settings
                        && self.fatf_blacklist_countries_settings.value
                        && self.fatf_blacklist_countries_settings.value.length){
                    self.fatf_blacklist_countries = self.fatf_blacklist_countries_settings.value;
                    self.haveBlacklistCountries = true;
                    // If blacklisted countries exist, update non-blacklisted countries list
                    self.refreshNonBlacklistedCountries();
                }
            }
        });
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){
            return null;
        }

        let setting = {};

        try{
            setting = settings.find(x => x.name == setting_name);

            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                }
                else{
                    setting.value = setting.value;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return setting;
    }



    // ---------- Session Timeout Settings -----------
    editSessionTimeoutSettings(editMode){
        const self = this;

        self.sessionTimeoutSettingsErrors = {};
        self.sessionTimeoutEditMode = editMode;
    }

    prepareSessionTimeoutResponse(){
        const self = this;
        let params = angular.copy(self.session_timeout);

        if(!self.session_timeout.value.enable)
        {
            params.value = {
                "name" : self.DEVELOPER_SETTINGS_SESSION_TIMEOUT,
                "enable" : false,
                "duration": 0
            };

            return params;
        }

        return params;
    }

    saveSessionTimeoutSettings(){
        const self = this;
        self.sessionTimeoutSettingsErrors = {};

        let url = 'sec/developer/settings';

        let params = self.prepareSessionTimeoutResponse();

        if(params.value.enable && params.value.duration <= 0){
            self.sessionTimeoutSettingsErrors.duration = "Value should be greater than 0";
            return;
        }

        try{
            params.value = JSON.stringify(params.value);
        }
        catch(ex){
            console.error(ex);
        }

        let handleResponse = function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Session timeout settings updated successfully.');
            self.sessionTimeoutEditMode = false;
            window.location.reload();
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    /**
     * Re-derive the "add a country" dropdown from the current blacklist.
     *
     * Every mutation of self.fatf_blacklist_countries has to go through here:
     * the dropdown must not offer a country that is already on the list, and
     * Nice Select renders its own markup once, so it needs an explicit 'update'
     * after the options change or the user keeps seeing the previous set.
     *
     * @returns {void}
     */
    refreshNonBlacklistedCountries() {
        const self = this;

        let blacklisted = self.fatf_blacklist_countries || [];

        self.non_blacklisted_countries = (self.countries || [])
            .filter(c => blacklisted.indexOf(c.country_code) === -1);

        self.$timeout(function () {
            $("select.eoi-select").niceSelect('update');
        });
    }

    addFatfBlacklistCountry() {
        const self = this;

        if (!self.selectedCountryForBlackList) { return false; }

        self.fatf_blacklist_countries = self.fatf_blacklist_countries || [];
        if (self.fatf_blacklist_countries.indexOf(self.selectedCountryForBlackList) < 0) {
            self.fatf_blacklist_countries.push(self.selectedCountryForBlackList);

            self.refreshNonBlacklistedCountries();
        }
        self.selectedCountryForBlackList = "";
    }

    removeFatfBlacklistCountry(country_code){
        const self = this;

        self.fatf_blacklist_countries = self.fatf_blacklist_countries || [];
        if (country_code && self.fatf_blacklist_countries.indexOf(country_code) > -1) {
            self.fatf_blacklist_countries.splice(self.fatf_blacklist_countries.indexOf(country_code), 1);

            self.refreshNonBlacklistedCountries();
        }
    }

    _saveFatfBlacklistCountriesSettings(){
        const self = this;

        let fatf_blacklist_countries = self.fatf_blacklist_countries ? self.fatf_blacklist_countries : [];

        let url = 'sec/developer/settings';
        let params = {
            name: "fatf_blacklist_countries",
            value: JSON.stringify(fatf_blacklist_countries)
        }

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.isEditFatfCountries = false;
            self.haveBlacklistCountries = false;
            self.SSAlertService.success('Success!', 'FATF Blacklist/Greylist Countries settings updated successfully.');
            self.getDeveloperSettings();
        };

        loading(true);
        if (self.fatf_blacklist_countries_settings && self.fatf_blacklist_countries_settings.id) {
            url += '/' + self.fatf_blacklist_countries_settings.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    getCountryDisplayName(country_code){
        self = this;

        let countryDisplayName = "";
        if(self.countries
                && self.countries.length
                && self.countries.find(c => c.country_code === country_code)){
            countryDisplayName = self.countries.find(c => c.country_code === country_code).name;
        }
        return countryDisplayName;
    }

    onEditFatfBlacklistCountriesSettings(){
        const self = this;

        if (self.fatf_blacklist_countries_settings && self.fatf_blacklist_countries_settings.value) {
            self.fatf_blacklist_countries = angular.copy(self.fatf_blacklist_countries_settings.value);
        }

        self.isEditFatfCountries = true;
    }

    onCancelFatfBlacklistCountriesSettings(){
        const self = this;

        self.fatf_blacklist_countries = [];
        if (self.fatf_blacklist_countries_settings && self.fatf_blacklist_countries_settings.value) {
            self.fatf_blacklist_countries = angular.copy(self.fatf_blacklist_countries_settings.value);
        }

        if(!self.fatf_blacklist_countries.length){
            self.haveBlacklistCountries = false;
        }
        self.isEditFatfCountries = false;
    }

    /**
     * Enable/disable toggle for the FATF list.
     *
     * ng-change fires after ng-model has already flipped, so haveBlacklistCountries
     * holds the value the user just asked for. It is put back until they confirm,
     * and only then applied.
     *
     * @returns {void}
     */
    onEnableDisableFatfBlacklist(){
        const self = this;

        if(self.haveBlacklistCountries){
            self.haveBlacklistCountries = false;
            self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                'Are you sure you want to enable FATF blacklist/Greylist countries? \nThe latest published list of FATF blacklist/Greylist countries will be populated. You may customised as needed.',
                self.SSConfirmationService.TYPE_YES_NO,
                function () {
                    // WEB-4383: seeded from the server's canonical list rather than a
                    // copy of the codes kept here. The portal used to hold its own
                    // hardcoded vintage, which is how the three clients drifted apart
                    // and why a project could never be moved onto a newer publication.
                    // The toggle stays off if the fetch fails, so the user is never
                    // left with an "enabled" list the server did not supply.
                    self.SSCountryListService.getLatestCodes(
                        self.SSCountryListService.LIST_TYPE_FATF,
                        function (country_codes) {
                            self.haveBlacklistCountries = true;
                            self.fatf_blacklist_countries = country_codes;
                            self.refreshNonBlacklistedCountries();
                        }
                    );
                }
            );
        } else {
            self.haveBlacklistCountries = true;
            self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                'Are you sure you want to proceed to disable FATF blacklist/Greylist countries? \nThe list will be removed.',
                self.SSConfirmationService.TYPE_YES_NO,
                function (answer) {
                    self.haveBlacklistCountries = false;
                    self.fatf_blacklist_countries = [];
                    self._saveFatfBlacklistCountriesSettings();
                }
            );
        }
    }

    /**
     * WEB-4383 — "Fetch Latest": bring this project back onto the published FATF list.
     *
     * Two steps, both handled by SSCountryListService: a read-only preview that
     * opens the overwrite-warning popup, and, only if the user confirms there, the
     * write. Nothing changes if they cancel.
     *
     * @returns {void}
     */
    onFetchLatestFatfBlacklistCountries(){
        const self = this;

        self.SSCountryListService.fetchLatest(
            self.SSCountryListService.LIST_TYPE_FATF,
            function () {
                // Re-read rather than patching the local copy: the refresh wrote the
                // list server-side, and getDeveloperSettings() is what re-derives the
                // enabled flag and the "updated by / updated at" line from the saved
                // row. Cleared first because that method only switches the flag back
                // on when the reloaded list is non-empty.
                self.isEditFatfCountries = false;
                self.haveBlacklistCountries = false;
                self.fatf_blacklist_countries = [];
                self.getDeveloperSettings();
            }
        );
    }

}

FATFBlacklistCountriesController.$inject = [
    '$parse',
    '$timeout',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSUserService',
    'OTPService',
    'SSConfirmationService',
    'SSConfigService',
    'SSCountryListService'];
app.controller('FATFBlacklistCountriesController', FATFBlacklistCountriesController);

// WEB-4411/WEB-4414: `timepicker` is registered once for this bundle, in developer_settings.js, and
// `datepicker` once, globally, by services/key_handover.js. A copy here would link it twice.